import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center py-4 mt-12 dark:bg-gray-900">
      <div>&copy; SEFF MachineWorks</div>
      <Link
        className="mt-2 inline-block text-sm text-gray-300 underline-offset-4 hover:text-white hover:underline focus:outline-none focus:ring-2 focus:ring-white"
        to="/privacy"
      >
        Privacy Policy
      </Link>
    </footer>
  );
}
